var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$style.PWAsideBodyItem},[_c('header',{class:_vm.$style.PWAsideBodyItemHeader},[_vm._t("header",function(){return [_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]})],2),_vm._v(" "),(_vm.$slots.default)?_c('div',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }